import { useQuery } from '@tanstack/react-query';
import { previewTemplate } from '../services/documentTemplates';
import { documentTemplateKeys } from './documentTemplateKeys';

export const useVersionPreviewQuery = (templateId: string, versionId: string, revision: number, enabled: boolean) =>
  useQuery({
    queryKey: [...documentTemplateKeys.version(templateId, versionId), 'preview', revision],
    queryFn: () => previewTemplate(templateId, { versionId }),
    enabled,
    staleTime: 5 * 60 * 1000,
  });
